(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('division', {
            parent: 'entity',
            /*
            url: '/division?page&sort&search',
            */
            url: '/division?page&sort&search&actualFilter',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'telestatApp.division.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/division/divisions.html',
                    controller: 'DivisionController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                actualFilter: {
                    value: 'true',
                    squash: true
                },
                sort: {
                    /*
                    value: 'id,asc',
                    */
                    value: 'title,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        actualFilter: $stateParams.actualFilter,
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('division');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('division-detail', {
            parent: 'division',
            url: '/division/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'telestatApp.division.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/division/division-detail.html',
                    controller: 'DivisionDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('division');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Division', function($stateParams, Division) {
                    return Division.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'division',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('division-detail.edit', {
            parent: 'division-detail',
            url: '/detail/edit',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/division/division-dialog.html',
                    controller: 'DivisionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Division', function(Division) {
                            return Division.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('division.new', {
            parent: 'division',
            url: '/new',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/division/division-dialog.html',
                    controller: 'DivisionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                title: null,
                                name: null,
                                /*
                                actual: false,
                                */
                                actual: true,
                                externalId: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('division', null, { reload: 'division' });
                }, function() {
                    $state.go('division');
                });
            }]
        })
        .state('division.edit', {
            parent: 'division',
            url: '/{id}/edit',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/division/division-dialog.html',
                    controller: 'DivisionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Division', function(Division) {
                            return Division.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('division', null, { reload: 'division' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('division.delete', {
            parent: 'division',
            url: '/{id}/delete',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/division/division-delete-dialog.html',
                    controller: 'DivisionDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Division', function(Division) {
                            return Division.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('division', null, { reload: 'division' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
